export { default } from './BillingAccounts.container'



// WEBPACK FOOTER //
// ./src/pages/BillingAccounts/index.js